var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkCardExploreHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7768 78.3715L28.5769 75.1716L41.2539 62.5331H10V57.9947H41.2539L28.5769 45.3562L31.7768 42.1563L49.8844 60.2639L31.7768 78.3715ZM64.223 54.6255L46.1154 36.5179L64.223 18.4102L67.4229 21.5717L54.7459 34.2487H85.9998V38.787H54.7459L67.4229 51.4255L64.223 54.6255Z",
    fill: "#F0512C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkCardExploreHover);
export default __webpack_public_path__ + "static/media/linkCard_explore_hover.46a950c19cae10048324b820edf486f5.svg";
export { ForwardRef as ReactComponent };